import { render, staticRenderFns } from "./m-scene.vue?vue&type=template&id=dc2504c2&scoped=true&"
import script from "./m-scene.vue?vue&type=script&lang=ts&"
export * from "./m-scene.vue?vue&type=script&lang=ts&"
import style0 from "./m-scene.vue?vue&type=style&index=0&id=dc2504c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc2504c2",
  null
  
)

export default component.exports